<template>
  <section>
    <div class="title-container">
      <h2>Enter your details</h2>
      <p>Please complete all fields</p>
    </div>
    <form action="" autocomplete="off">
      <div class="form-field" :class="{bad: error_message_fname}">
        <label for="">First name*</label>
        <input type="text"  v-model="customer.firstname">
        <p class="error" v-if="error_message_fname !=''">{{error_message_fname}}</p>
      </div>
      <div :class="{bad: error_message_lname != ''}">
        <label for="">Last name*</label>
        <input type="text"  v-model="customer.lastname">
        <p class="error" v-if="error_message_lname != ''">{{error_message_lname}}</p>
      </div>
      <div :class="{bad: error_message_dob}">
        <label for="">Date of birth*</label>
        <p>For example, 30 1 1953</p>
        <div class="form-group same-line">
          <input type="number" min="1" max="31" step="1" v-model="customer.dob.day">
          <input type="number" min="1" max="12" step="1" v-model="customer.dob.month">
          <input type="number" :min="yearMin" :max="yearMax" step="1" v-model="customer.dob.year">
        </div>
        <p class="last">We need to confirm that you are over 18 years old.</p>
        <p class="error" v-if="error_message_dob != ''">{{error_message_dob}}</p>
      </div>

      <div :class="{bad: error_message_email}">
        <label for="">Email*</label>
        <p>So we can send you confirmation of your appointment with us.</p>
        <input type="email"  v-model="customer.email">
        <p class="error" v-if="error_message_email != ''">{{error_message_email}}</p>
      </div>

      <div :class="{bad: error_message_phone}">
        <label for="">Phone number*</label>
        <p>So we can contact you about your appointment should we need to.</p>
        <input type="tel"  v-model="customer.phone">
        <p class="error" v-if="error_message_phone != ''">{{error_message_phone}}</p>
      </div>

      <div class="privacy">
        <h3>Your Privacy</h3>
        <label for=""><input type="checkbox"  v-model="customer.privacy"><div>*I agree to the handling of my personal information in<br/> accordance with Leightons Opticians & Hearing Care <a :href="(privacyURL)" target="_blank">Privacy Policy</a>.</div></label>
      </div>

      <div :class="{'checking-appointment': true, active: isSendingData}">
        <span class="spinner"></span>
        <p>We're just confirming your appointment. Please do not refresh this page.</p>
      </div>

      <div>
        <label style="position: absolute;top: 0;left: 0;z-index: -1;width: 0;height: 0;opacity: 0;">
          <span>No spam</span>
          <input v-model="hs_value" autocomplete="off" tabindex="-1" type="text" />
        </label>
      </div>

<!-- display form messages -->
      <div class="message">
        <div class="bad" v-if="error_message != ''">
          <div v-html="error_message"></div>
        </div>
      </div>

      <div class="submit">
        <button @click.prevent="onFormSubmit" :disabled="!this.customer.privacy || isSendingData" class="btn">{{ getBookingButtonLabel }}</button>
      </div>

      <template v-if="checkFormFields"></template>
    </form>
  </section>
</template>

<script>

//import VueHcaptcha from "@hcaptcha/vue3-hcaptcha";
export default {
  name: "BookingCustomer",
  props: ["appointment"],
  //components: {VueHcaptcha},
  created() {
    this.currentURL = location.host;
    this.homeURL = location.protocol + "//" + location.host.replace('booking.', window.domainPrefix ? window.domainPrefix : '');
    this.privacyURL = 'https://www.leightons.co.uk/privacy-cookies/';
    this.termsURL = 'https://www.leightons.co.uk/terms-conditions/';
  },
  data() {
    return {
      isSendingData: false,
      error_message: '',

      error_message_dob: '',
      error_message_email: '',
      error_message_fname: '',
      error_message_lname: '',
      error_message_phone: '',

      is_submit_at_least_once: false,
      //hcaptcha_sitekey: '',
      //error_message_hcaptcha: '',
      //hcaptcha_verified: false,
      hs_value: ''
    }
  },
  mounted() {
    //this.hcaptcha_sitekey = window.wpHcaptcha.sitekey;
    window.scrollTo(0, 0);
  },
  computed: {
    hcaptcha_verified() {
      return this.hs_value === '';
    },
    getBookingButtonLabel() {
      return this.isSendingData ? "Booking in progress" : "Book Appointment";
    },
    customer () {
      return this.appointment.customer;
    },
    yearMin () {
      const now = new Date()
      return now.getFullYear() - 110;
    },
    yearMax () {
      const now = new Date()
      return now.getFullYear();
    },
    checkFormFields() {
      if (!this.is_submit_at_least_once) {
        return false;
      }
      return this.isFormValid();
    },
  },
  methods: {
    isFormValid () {
      // validation stuff
      this.validate_form_dob();
      this.validate_form_email();
      this.validate_form_name_phone();
      if (this.customer.firstname != "" && this.customer.lastname != "" &&
            this.customer.dob.year != "" && this.customer.dob.month != "" && this.customer.dob.day != "" &&
            this.customer.email != "" && this.customer.phone != "" &&
            this.customer.privacy == true &&
            this.hcaptcha_verified) {
        return this.validateFormData();
      }
      return false;
    },
    validate_form_dob() {
      this.error_message_dob = "";
      if (this.customer.dob.year != "" && this.customer.dob.month != "" && this.customer.dob.day != "") {
        if (!this.validDob(this.customer.dob.year, this.customer.dob.month, this.customer.dob.day) || (this.customer.dob.year < 1900)) {
          this.error_message_dob = 'Date of birth is invalid';
        } else if (!this.validAge(this.customer.dob.year, this.customer.dob.month, this.customer.dob.day, 18)) {
          this.error_message_dob = 'You are not over 18';
        } else if (this.validAge(this.customer.dob.year, this.customer.dob.month, this.customer.dob.day, 120)) {
          this.error_message_dob = 'You are too old to take the service';
        }
      } else {
        this.error_message_dob = "Please fill out this field.";
      }
    },
    validate_form_email() {
      this.error_message_email = "";
      this.customer.email = this.customer.email.trim();
      if (this.customer.email != "") {
        if (!this.validEmail(this.customer.email)) {
          this.error_message_email = 'Email is invalid';
        }
      } else {
        this.error_message_email = "Please fill out this field.";
      }
    },
    validate_form_name_phone() {
      this.error_message_fname = "";
      this.customer.firstname = this.customer.firstname.trim();
      if (this.customer.firstname === "") {
        this.error_message_fname = "Please fill out this field.";
      }

      this.error_message_lname = "";
      this.customer.lastname = this.customer.lastname.trim();
      if (this.customer.lastname === "") {
        this.error_message_lname = "Please fill out this field.";
      }

      this.error_message_phone = "";
      if (this.customer.phone === "") {
        this.error_message_phone = "Please fill out this field.";
      }

      // Validate phone number is less than 12 digits
      if (this.customer.phone.length > 12) {
        this.error_message_phone = "Phone number is invalid";
      }

      this.error_message_hcaptcha = "";
      if (!this.hcaptcha_verified) {
        this.error_message_hcaptcha = "hCaptcha is not verified yet.";
      }
    },
    stage(stage) {
      this.$emit("stage", stage);
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validDob(year,month,day) {
      month = month - 1;
      var d = new Date(year, month, day);
      if (d.getFullYear() == year && d.getMonth() == month && d.getDate() == day) {
        return true;
      }
      return false;
    },
    validAge(year,month,day, minAge) {
      month = month - 1;
      const date = new Date(year, month, day);
      const now = new Date();
      const current_year = now.getFullYear();
      const year_diff = current_year - date.getFullYear();
      const birthday_this_year = new Date(current_year, date.getMonth(), date.getDate());
      const has_had_birthday_this_year = (now >= birthday_this_year);

      const ageYear = has_had_birthday_this_year
          ? year_diff
          : year_diff - 1;
      return ageYear - minAge >= 0;
    },
    validateFormData() {
      if (this.error_message_dob !== "" ||
          this.error_message_email !== "" ||
          this.error_message_fname !== "" ||
          this.error_message_lname !== "" ||
          this.error_message_phone !== "" ||
          this.error_message_hcaptcha !== ""
          ) {
        return false;
      }
      this.error_message = "";
      return true;
    },
    onFormSubmit() {
      this.error_message = "";
      if (!this.isFormValid()) {
        this.is_submit_at_least_once = true;
        if (this.hcaptcha_verified) {
          this.error_message = "One or more fields have an error. Please check and try again.";
        } else {
          this.error_message = "Looks like you are a bot. Stops the proccess.";
        }
        return;
      }
      this.is_submit_at_least_once = true;
      let receiveupdateby = [];
      /*if (this.customer.signup.email == true) {
        receiveupdateby.push('email');
      }
      if (this.customer.signup.sms == true) {
        receiveupdateby.push('sms');
      }
      if (this.customer.signup.post == true) {
        receiveupdateby.push('post');
      }*/
      const price = this.appointment.service.price ?? "";
      const form_data = {
        timeslot_id: this.appointment.date.id,
        timeslot_value: `${this.appointment.date.date};${this.appointment.date.time}`,
        timeslot_calendar_value: this.appointment.date.calendar_date,
        service_id: this.appointment.service.id,
        service_value: `${this.appointment.service.code};${this.appointment.service.title};${price}`,
        location_id: this.appointment.practice.ad_location_id,
        location_value: `${this.appointment.practice.post_title};${this.appointment.practice.ad_address};${this.appointment.service.duration}`,
        location_latlng: this.appointment.practice.ad_latlng,
        location_url: this.appointment.practice.post_url,
        location_email: this.appointment.practice.email,
        location_website: this.appointment.practice.website,
        location_phone: this.appointment.practice.telephone,
        firstname: this.customer.firstname,
        lastname: this.customer.lastname,
        dob: `${this.customer.dob.day}-${this.customer.dob.month}-${this.customer.dob.year}`,
        email: this.customer.email,
        phone: this.customer.phone,
        message: this.customer.extra ? this.customer.extra : '',
        receiveupdateby: receiveupdateby.join(','),
      };

      this.isSendingData = true;
      const api = window.wpAjax.ajaxUrl + "?action=book_appointment";
      const thisView = this;
      this.axios.post("/wp-json/leightons/v1/book-appointment", { booking: form_data })
        .then((response) => {
          this.error_message = '';
          let has_error = true;

          if (response.data.success == true) {
            if (response.data.data.errorCode == 0) {
              has_error = false;
              //move to Appointment Detail page
              setTimeout(() => {
                const confirmation_url = `/confirmation/${response.data.data.booking.appointment_id}`;
                thisView.$router.push(confirmation_url);
              }, 500);//wait for 0.5 second
            }
          }

          if (has_error) {
            this.error_message = "<h4 class=''>Your selected appointment is no longer available.</h4><p>We're sorry, but the appointment time you've selected is no longer available to book. Please choose another time slot or call our team on 0800 52 00 546.</p>";
          }
        }).catch((error) => {
          this.error_message = error;
        })
        .finally(() => {
          this.isSendingData = false;
        });
    }
  },
};

</script>

<style lang="postcss" scoped>
section {
  @apply w-full sm:w-[630px] mx-auto pb-[70px] sm:pb-[130px] pt-[45px] px-[30px] sm:px-0;

  .title-container {
    @apply text-center border-b border-grey-darker pb-[30px] mb-[30px];

    h2 {
      @apply text-[25px] sm:text-[30px] tracking-wider leading-tight font-brandon-black text-grey-darker uppercase mb-[10px];
    }

    p {
      @apply tracking-wide text-[20px] text-grey-darker;
    }
  }

  form {

    /* error message text */
    .error {
      @apply text-error font-bold mt-1.5;
    }

    .error.hcapt {
      @apply mt-[-25px];
    }

    label {
      @apply font-avenir-medium;
    }

    div {
      @apply mb-[30px];
    }

    h3 {
      @apply text-[18px] text-[#103C62] uppercase tracking-wider mb-[20px] sm:mb-[10px] font-bold;
    }

    /* p label {
      @apply text-[18px] text-[#103C62];
    } */

    p {
      @apply text-[#446481];
    }

    p.last {
      @apply mt-[15px];
    }

    input[type="text"] {
      @apply w-full p-[10px] mt-[10px] rounded-md border border-grey-darker;
    }

    input[type="email"] {
      @apply w-full p-[10px] mt-[10px] rounded-md border border-grey-darker;
    }

    input[type="tel"] {
      @apply w-full p-[10px] mt-[10px] rounded-md border border-grey-darker;
    }

    textarea {
      @apply w-full h-[190px] p-[10px] mt-[10px] rounded-md border border-grey-darker resize-none;
    }

    input[type="number"] {
      @apply p-[10px] mr-[30px] mt-[10px] rounded-md border border-grey-darker;
    }

    .same-line {
      input[type="number"] {
        @apply mr-4 max-w-[calc((100%_-_2rem)_/_3)];

        &:last-child {
          @apply mr-0;
        }
      }
    }

    input[type="checkbox"] {
      @apply mr-[15px] border-[#62829B] border-[1px] w-[30px] h-[30px] rounded-md;
    }

    input[type=checkbox]:checked {
      @apply accent-purple-darker;
    }

    /* input errors. Note: important this comes after the other input declarations */
    .bad input, .bad select, .bad textarea {
      @apply outline outline-error border-0;
    }

    .news {

      span {
        @apply my-[20px] grid grid-cols-1 sm:grid-cols-3;
      }

      label {
        @apply mb-[15px] sm:m-0 flex text-[#446481] leading-7 justify-start;
      }

      label:nth-of-type(2) {
        @apply sm:justify-center;
      }

      label:nth-of-type(3) {
        @apply sm:justify-end;
      }
    }

    .privacy {
      h3 {
        @apply text-purple-darker;
      }

      a {
        @apply underline;
      }

      label {
        @apply my-[20px] flex text-grey-darker leading-normal;

        input {
          @apply shrink-0;
        }
      }

      br {
        @apply hidden sm:block
      }
    }

    .checking-appointment {
      @apply hidden text-center;

      &.active {
        @apply block;
      }

      > span {
        @apply inline-block border-pink border-[3px] border-r-transparent rounded-full w-[60px] h-[60px] animate-spin;
      }

      p {
        @apply mt-4;
      }
    }

    /* error block at bottom */
    .bad {
      @apply text-[rgb(16,60,90)] rounded-md border-error border-2 mt-2.5 p-10 bg-white;

      > div {
        @apply mb-0;

        >>> p {
          @apply text-[rgb(16,60,90)];
        }

        >>> h4 {
          @apply mb-3 font-bold;
        }
      }

      button,
      .btn  {
        @apply block mx-auto;
      }
    }
  }

  .submit {
    @apply text-center mt-[30px] mb-0 pt-[40px] border-t border-navy border-opacity-20;

    button {
      @apply sm:w-auto w-full sm:px-[80px];
    }
  }
}
</style>